import React from "react"

export default function Header ({status}) {
  return (
    <div className="title-bar flex-row" >
      <h4 className="padding-0 margin-0" >Project Details</h4>
      <div className="status-bubble">{status}</div>
    </div>        
  )    
}